import { Clock, Activity, Sparkles } from 'lucide-react'
import type { SubTabId } from '@/components/Configuracao/esforcoTimeTypes'

type Props = {
  totalHoursFormatted: string
  taskCount: number
  activeSubTab: SubTabId
}

export function EsforcoTimeSummaryCards({ totalHoursFormatted, taskCount, activeSubTab }: Props) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div className="glass-card p-5 flex items-center justify-between">
        <div className="space-y-1">
          <p className="text-text-muted text-[10px] uppercase font-bold tracking-wider">Esforço Total Estimado</p>
          <h4 className="text-2xl font-bold text-accent">{totalHoursFormatted}</h4>
        </div>
        <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center text-accent">
          <Clock size={20} />
        </div>
      </div>

      <div className="glass-card p-5 flex items-center justify-between">
        <div className="space-y-1">
          <p className="text-text-muted text-[10px] uppercase font-bold tracking-wider">Quantidade de Tarefas</p>
          <h4 className="text-2xl font-bold text-text-primary">{taskCount}</h4>
        </div>
        <div className="w-10 h-10 rounded-lg bg-white/[0.04] border border-white/[0.06] flex items-center justify-center text-text-muted">
          <Activity size={20} />
        </div>
      </div>

      <div className="glass-card p-5 flex items-center justify-between">
        <div className="space-y-1">
          <p className="text-text-muted text-[10px] uppercase font-bold tracking-wider">Área Selecionada</p>
          <h4 className="text-2xl font-bold text-text-primary capitalize">{activeSubTab}</h4>
        </div>
        <div className="w-10 h-10 rounded-lg bg-white/[0.04] border border-white/[0.06] flex items-center justify-center text-text-muted">
          <Sparkles size={20} />
        </div>
      </div>
    </div>
  )
}
